//import React from 'react';
//import { Container, Row, Col, Card } from 'react-bootstrap';
//
//const stats = [
//  { value: '10K+', label: 'Customer Satisfaction' },
//  { value: '200%+', label: 'Revenue Increase' },
//  { value: '20x', label: 'Business Growth' }
//];
//
//const Stats = () => (
//  <section className="stats__v3 section">
//    <Container>
//      <Row className='stat-div pd-tb-40'>
//        {stats.map((stat, idx) => (
//          <Col key={idx} xs={12} sm={6} md={4} className="text-center">
//            <Col className="stat-item p-4">
//              <Card.Body>
//                <Card.Title as="h3" className="fs-1 fw-bold clr-wh">{stat.value}</Card.Title>
//                <Card.Text className="mb-0 clr-wh">{stat.label}</Card.Text>
//              </Card.Body>
//            </Col>
//            <div className='st stat-inner1'></div>
//            <div className='st stat-inner2'></div>
//            <div className='st stat-inner3'></div>
//          </Col>
//        ))}
//      </Row>
//    </Container>
//  </section>
//);
//
//export default Stats; 







import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const stats = [
  { value: '10K+', label: 'Customer Satisfaction' },
  { value: '200%+', label: 'Revenue Increase' },
  { value: '20x', label: 'Business Growth' }
];

const Stats = () => (
  <section className="stats__v3 section">
    <Container>
      <Row className="stat-div pd-tb-40 justify-content-center">
        {stats.map((stat, idx) => (
          <Col key={idx} xs={12} sm={6} md={4} className="text-center mb-4 mb-md-0">
            <div className="stat-item p-4 position-relative">
              <Card.Body>
                <Card.Title as="h3" className="fs-1 fw-bold clr-wh">{stat.value}</Card.Title>
                <Card.Text className="mb-0 clr-wh">{stat.label}</Card.Text>
              </Card.Body>
              <div className='st stat-inner1'></div>
              <div className='st stat-inner2'></div>
              <div className='st stat-inner3'></div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default Stats;
